export class EComplianceTabIndex {
    public static readonly StudentAthleteInfo = '0';
    public static readonly LSUSeasonData = '1';
    public static readonly TransferSeasonData = '2';
    public static readonly SeasonSummary = '3';
    public static readonly Correspondence = '4';
    public static readonly Documents = '5';
    public static readonly Notes = '6';
}